import React, { Component } from 'react';
import WrappedIntlComponent from '../common/intl/WrappedIntlComponent';
import Wrapper from '../common/Wrapper';
import Submenu from '../common/Submenu';
import cn from 'classnames'
import Spiner from '../helpers/Spiner/Spiner';
import { getTrasheds, recoveryQuestion, removeQuestion } from './actions';
import Question from './components/Question';
import { getCategories, getSubcategories, getSubjects, getBranch, getSource } from '../Quiz/actions';
import { Pagination } from 'antd';
import {cloneDeep} from 'lodash';
import './style.scss';
import PropTypes from 'prop-types'
import { routesUrls } from '../../settings/routes';
import { MenuItem} from 'react-bootstrap'
import history from '../../history';
import { recoverTrash, removeTrash } from '../../modules/questions';
import { connect } from 'react-redux'
import {toastr} from 'react-redux-toastr'

class CustomItems extends Component {
  static contextTypes = {formatMessage: PropTypes.any}
  render() {
    const {formatMessage} = this.context;
    return <React.Fragment>
      <MenuItem
        onClick={() => {
          history.push(routesUrls.dashboard)
        }}
      >{formatMessage('navTitleDashboard')}</MenuItem>
      <MenuItem
        
        onClick={() => {
          history.push(routesUrls.questions)
        }}
      >{formatMessage('navTitleQuestions')}</MenuItem>
   </React.Fragment>
  }
}

class Trashed extends Component {

  constructor(props) {
    super(props)
    this.state = {
      loaded: false,
      questions_data: [],
      questions: [],
      categories: [],
      subcategories: [],
      subjects: [],
      branches: [],
      sources: [],
      pageSize: 10,
			currentPage: 1,
    }
  }

  async componentDidMount(){
    const {formatMessage} = this.props;
    try {
      const questions_data = await getTrasheds();
      const [categories, subcategories, subjects, branches, sources ] = await Promise.all([
        getCategories(),
        getSubcategories(),
        getSubjects(),
        getBranch(),
        getSource(),
      ]);

      this.setState({
        questions_data,
        questions: this.paginate(questions_data, 10, 1),
        categories,
        subcategories,
        subjects,
        branches,
        sources,
        loaded: true
      });
    } catch (error) {
      this.setState({
        loaded: true
      })
      toastr.error(formatMessage('msgTrashedQuestionTitle'), formatMessage('msgTrashedQuestionMessage'))
    }
  }

  paginate = (array, page_size, page_number) => {
		--page_number;
		return cloneDeep(array).slice(page_number * page_size, (page_number + 1) * page_size);
  }
  
  onShowSizeChange = (current, pageSize) => {
		this.setState({
			questions: this.paginate(this.state.questions_data, pageSize, current),
			pageSize,
			currentPage: current
		})
  }
  
  scrollToTop(scrollDuration) {
    var scrollStep = -window.scrollY / (scrollDuration / 15),
        scrollInterval = setInterval(function(){
            if ( window.scrollY != 0 ) {
                window.scrollBy( 0, scrollStep );
            }
            else clearInterval(scrollInterval); 
        }, 15);
  }
  
  recoveryQuestion = async (id, values) => {
    const { questions_data, questions, pageSize, currentPage } = this.state;
    await recoveryQuestion(id, values);
    const data = questions_data.filter(item => item.id != id);
    this.setState({
      questions_data: data,
      questions: this.paginate(data, pageSize, currentPage),
    })
  }
   
  deleteQuestion = async (id) => {
    const { questions_data, questions, pageSize, currentPage } = this.state;
    await removeQuestion({trashedQuestionId : id});
    const data = questions_data.filter(item => item.id != id);
    this.setState({
      questions_data: data,
      questions: this.paginate(data.filter(item => item.id != id), pageSize, currentPage),
    })
  }
  

  render() {
    const {loaded, categories, subjects, sources, branches, subcategories} = this.state;
    const {questions_data, questions, pageSize, currentPage} = this.state;
    return (
      <Wrapper renderButtonNav = {false} CustomItems={CustomItems}>
        <div className="qbm-content Trashed">
          {!loaded ? <Spiner/> : 
            <div className="Questions question-container">
              <div>
                {questions.map(question => (
                  <Question 
                    key={'question-' + question.id} 
                    question={question} 
                    subjects={subjects} 
                    categories={categories} 
                    sources={sources} 
                    branches={branches} 
                    subcategories={subcategories} 
                    deleteQuestion={this.deleteQuestion} 
                    recoveryQuestion={this.recoveryQuestion} 
                  />))}
              </div>
              {questions.length != 0 && <Pagination
                showSizeChanger
                onShowSizeChange={this.onShowSizeChange}
                total={questions_data.length}
                pageSizeOptions={['5', '10', '20', '50']}
                pageSize={pageSize}
                current={currentPage}
                onChange={(page, pageSize) => {
                  this.setState({
                    questions: this.paginate(this.state.questions_data, pageSize, page),
                    pageSize,
                    currentPage: page,
                  }, () => {
                    this.scrollToTop(500);
                  })
                }}
              />}
            </div>
          }
        </div>
      </Wrapper>
    );
  }
}



const mapStateToProps = (state, ownProps) => ({
  recoverTrash,
  removeTrash,
})

const mapDispatchToProps = {
  
}

export default WrappedIntlComponent(connect(mapStateToProps, mapDispatchToProps)(Trashed))





// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/Trashed/index.jsx